import type { ExchangeProjectContextDto } from '@inference.engine/api-client';
import type { FileAssetWithUrl } from '@/features/chats/model/chats.types';
import { ChatMessageFiles } from '../ChatMessageFiles/ChatMessageFiles';
import { ChatMessageProjectContext } from '../ChatMessageProjectContext';

interface Props {
  files?: FileAssetWithUrl[];
  projectContext?: ExchangeProjectContextDto | null;
  type: 'user' | 'assistant';
  /** Agent that produced an assistant message; gates the file "Add to library" action. */
  agentId?: string;
}

/**
 * Single entry point for the attachments shown on a message — uploaded files
 * and attached project context. Both are point-in-time snapshots rendered as
 * re-attachable chips, so one component owns "what's attached to this message"
 * wherever a bubble renders (user, assistant, loading), instead of each call
 * site wiring the two chip kinds separately.
 */
export function MessageAttachments(props: Props) {
  const files = props.files ?? [];
  const hasFiles = files.length > 0;
  const hasProjectContext = !!props.projectContext && props.projectContext.items.length > 0;

  if (!hasFiles && !hasProjectContext) return null;

  return (
    <>
      {hasFiles && <ChatMessageFiles files={files} type={props.type} agentId={props.agentId} />}
      {hasProjectContext && props.projectContext && (
        <ChatMessageProjectContext projectContext={props.projectContext} type={props.type} />
      )}
    </>
  );
}
